export class AppSettings {
  public environment: string;
  public apiUrl: string;
  public administrationPageUrl: string;
  public appInsightsInstrumentationKey: string;
  public googleAnalyticsKey: string;
  public apiSubscriberKey: string;
}
